module.exports = ".help_container {\n  text-align: center; }\n\n.help_text {\n  margin-bottom: 2em; }\n\n.help_contacts p:not(:last-child) {\n  margin-bottom: 0.5em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/help/help.scss
// module id = wSvC
// module chunks = 12